import { AxiosResponse } from 'axios';
import { ActionTypes } from '../../constants/ActionTypes';
import { IItem, IReplyForAllPrams, IArrayItem } from '../../interfaces';
import {
  IQuickAssignParams,
  IUploadReferFile,
  IRemoveReferFile,
  IServerAssignDetail,
} from '../../interfaces/Assign';

export const onClearAssignDetail = () => {
  return {
    type: ActionTypes.CLEAR_ASSIGN_DETAILS_STATE,
  };
};

export const onGetReferDetail = () => {
  return {
    type: ActionTypes.GET_REFER_DETAILS,
  };
};

export const onGetReceiversForReply = (params: IReplyForAllPrams) => {
  return {
    type: ActionTypes.GET_RECEIVERS_FOR_REPLY,
    payload: params,
  };
};

export const fetchReceiversForReplySuccess = (
  replyReceiversList: AxiosResponse,
) => {
  return {
    type: ActionTypes.FETCH_RECEIVERS_FOR_REPLY_SUCCESS,
    payload: replyReceiversList,
  };
};

export const onGetLetterReferTypes = () => {
  return {
    type: ActionTypes.GET_LETTER_REFER_TYPES,
  };
};

export const fetchLetterReferTypesSuccess = (
  letterReferTypes: AxiosResponse,
) => {
  return {
    type: ActionTypes.FETCH_LETTER_REFER_TYPES_SUCCESS,
    payload: letterReferTypes,
  };
};

export const onGetLetterReferSendTypes = () => {
  return {
    type: ActionTypes.GET_LETTER_REFER_SEND_TYPES,
  };
};

export const fetchLetterReferSendTypesSuccess = (
  letterReferSendTypes: AxiosResponse,
) => {
  return {
    type: ActionTypes.FETCH_LETTER_REFER_SEND_TYPES_SUCCESS,
    payload: letterReferSendTypes,
  };
};

export const changeAssignStateItemsValueWithType = (item: IItem) => {
  return {
    type: ActionTypes.CHANGE_ASSIGN_STATE_ITEMS_VALUE_WITH_TYPE,
    payload: item,
  };
};

export const changeAssignStateItemsValue = (item: IItem) => {
  return {
    type: ActionTypes.CHANGE_ASSIGN_STATE_ITEMS_VALUE,
    payload: item,
  };
};

export const changeAssignStateFieldsItemsValue = (item: IItem) => {
  return {
    type: ActionTypes.CHANGE_ASSIGN_STATE_FILEDS_ITEMS_VALUE,
    payload: item,
  };
};

export const changeAssignStateLetterRefersItemsValue = (item: IArrayItem) => {
  return {
    type: ActionTypes.CHANGE_ASSIGN_STATE_LETTER_REFERS_ITEMS_VALUE,
    payload: item,
  };
};

export const changeAssignStateLetterRefersItemsValueWithType = (
  item: IArrayItem,
) => {
  return {
    type: ActionTypes.CHANGE_ASSIGN_STATE_LETTER_REFERS_ITEMS_VALUE_WITH_TYPE,
    payload: item,
  };
};

export const onSendRefer = (assignDetail: IServerAssignDetail) => {
  return {
    type: ActionTypes.SEND_REFER,
    payload: assignDetail,
  };
};

export const onSendReferSuccess = () => {
  return {
    type: ActionTypes.SEND_REFER_SUCCESS,
  };
};

export const onFastRefer = (quickAssignModel: IQuickAssignParams) => {
  return {
    type: ActionTypes.FAST_REFER,
    payload: quickAssignModel,
  };
};

export const onFastReferSuccess = () => {
  return {
    type: ActionTypes.FAST_REFER_SUCCESS,
    payload: true,
  };
};

export const onRemoveAssignBodyLetterRefersItemArray = (arrayIndex: number) => {
  return {
    type: ActionTypes.ON_ASSIGN_BODY_LETTER_REFER_ARRAY_ITEM,
    payload: arrayIndex,
  };
};

export const onUploadReferFile = (args: IUploadReferFile) => {
  return {
    type: ActionTypes.UPLOAD_REFER_FILE,
    payload: args,
  };
};

export const onUploadReferFileSuccess = () => {
  return {
    type: ActionTypes.UPLOAD_REFER_FILE_SUCCESS,
    payload: true,
  };
};

export const onRemoveReferFile = (args: IRemoveReferFile) => {
  return {
    type: ActionTypes.REMOVE_REFER_FILE,
    payload: args,
  };
};

export const onRemoveReferFileSuccess = () => {
  return {
    type: ActionTypes.REMOVE_REFER_FILE_SUCCESS,
    payload: true,
  };
};
